import React from 'react'
import "./UaeService.css"

const UaeServiceHead = (props) => {
  return (
    <div className='uaeServiceHeadContainer'>
      <h1>{props.head}</h1>
    </div>
  )
}

export default UaeServiceHead
